<!-- 科目详情 -->
<template>
<div class="subject-details">
    <div class="container">
        <div class="container-content">
            <img class="subject-banner" :src="subjectinfo.banner" />
            <div class="text-info">
                <div class="subject-title">{{ subjectinfo.showLabel }}</div>
                <div class="uprice-box">
                    <div class="label">价格：</div>
                    <div class="uprice">￥{{ subjectinfo.uprice }}</div>
                </div>
                <div class="info-item">
                    <div class="label">适用人群：</div>
                    <div class="info-box">
                        <div class="info">有一定自律学习意识，希望考前系统备考的考生</div>
                    </div>
                </div>
                <div class="info-item">
                    <div class="label">题库特色：</div>
                    <div class="info-box">
                        <div class="info">章节习题练习</div>
                        <div class="info">历年真题详解</div>
                        <div class="info">错题自动记录</div>
                        <div class="info">在线模拟试题</div>
                    </div>
                </div>
                <div class="info-item">
                    <div class="label">有 效 期：</div>
                    <div class="info-box">
                        <div class="info">购买后12个月</div>
                    </div>
                </div>
                <div class="buy-btn pointer" @click="handleOpenBuy">立即购买</div>
            </div>
        </div>
        <div class="details-box">
            <img :src="require('@/common/images/mSpecialTopic/details/jjcy_1.jpg')" class="details-img" v-if="subjectinfo.examcode === 'jjcy'" style="height: 561px" />
            <img :src="require('@/common/images/mSpecialTopic/details/zqcy_1.jpg')" class="details-img" v-if="subjectinfo.examcode === 'zqcy'" style="height: 561px" />
            <img :src="require('@/common/images/mSpecialTopic/details/qhcy_1.jpg')" class="details-img" v-if="subjectinfo.examcode === 'qhcy'" style="height: 561px" />
            <img :src="require('@/common/images/mSpecialTopic/details/details_2.jpg')" class="details-img" style="height: 727px" />
            <img :src="require('@/common/images/mSpecialTopic/details/details_3.jpg')" class="details-img" style="height: 636px" />
            <img :src="require('@/common/images/mSpecialTopic/details/details_4.jpg')" class="details-img" style="height: 1072px" />
            <img :src="require('@/common/images/mSpecialTopic/details/details_5.jpg')" class="details-img" style="height: 767px" />
            <img :src="require('@/common/images/mSpecialTopic/details/details_6.jpg')" class="details-img" style="height: 1440px" />
        </div>
    </div>
    <BuyPopup ref="buyPopup" :subject="{code: subjectinfo.subjectcode, name: subjectinfo.subjectname}"></BuyPopup>
</div>
</template>

<script>
import BuyPopup from './component/buyDialog.vue'
export default {
    data() {
        return {
            subjectinfo: {}
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        if (localStorage.getItem('topicItem')) {
            this.subjectinfo = JSON.parse(localStorage.getItem('topicItem'))
        } else {
            location.replace = location.origin + '/specialTopic/' + this.$route.params.examcode + '/choose'
        }
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleOpenBuy() {
            this.$refs.buyPopup.handleOpen(this.subjectinfo.examcode)
        }
    },
    components: {
        BuyPopup
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.subject-details {
    background: #fff;
    min-height: calc(100vh - 75px);
    .container-content {
        padding: 30px 0;
        display: flex;
        .subject-banner {
            width: 510px;
            height: 286px;
            margin-right: 70px;
        }
        .text-info {
            flex: 1;
            width: 0;
            .subject-title {
                font-size: 20px;
                color: #333333;
                line-height: 28px;
                margin-bottom: 15px;
                font-weight: bold;
            }
            .uprice-box {
                display: flex;
                align-items: center;
                height: 56px;
                background: rgba(245,108,108,0.1);
                padding: 0 20px;
                margin-bottom: 15px;
                .label {
                    font-size: 14px;
                    color: #999999;
                }
                .uprice {
                    font-size: 28px;
                    color: #FA2B19;
                    font-weight: bold;
                }
            }
            .info-item {
                display: flex;
                align-items: center;
                margin-bottom: 15px;
                .label {
                    font-size: 14px;
                    color: #999999;
                    line-height: 20px;
                    width: 70px;
                }
                .info-box {
                    display: flex;
                    .info {
                        padding: 0 15px;
                        background: rgba(255,153,80,0.1);
                        color: #DE772E;
                        font-size: 12px;
                        margin-right: 10px;
                        line-height: 26px;
                    }
                }
            }
            .buy-btn {
                width: 158px;
                height: 48px;
                background: #FF982B;
                border-radius: 4px;
                text-align: center;
                line-height: 48px;
                color: #fff;
                font-size: 18px;
            }
        }
    }
    .details-box {
        .details-img {
            width: 750px;
            vertical-align: middle;
            margin: 0 auto;
        }
    }
}
</style>